import { FC } from 'react'

import styled from 'styled-components'

import TrustPilot from 'src/Assets/Svg/logo-trustpilot.svg?react'
import { variables } from 'src/Styled/variables'

const Link = styled.a`
  font-family: Segoe UI;
  cursor: pointer;
  display: flex;
  height: 22px;
  max-width: 240px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border: ${({ theme }) => `1px solid ${theme.button.primaryBorder}`};
  border-radius: 8px;
  background: ${({ theme }) => theme.button.primaryBg};
  color: ${({ theme }) => theme.button.thirdText};
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  box-sizing: content-box;

  &:hover {
    background: ${({ theme }) => theme.button.hoverBg};
  }

  span {
    flex-shrink: 0;
  }

  &:focus-visible {
    outline: ${({ theme }) => `1px solid ${theme.button.sixthBorder}`};
    outline-offset: -2px;
    background: ${({ theme }) => theme.button.hoverBg};
  }
`

export interface TrustpilotButtonLinkProps {
  url: string
}

export const TrustpilotButtonLink: FC<TrustpilotButtonLinkProps> = ({
  url,
}) => (
  <Link href={url} target='_blank' rel='noopener noreferrer'>
    <span>Read on</span>
    <TrustPilot width={90} height={27} />
  </Link>
)
